import React from 'react';
import './MySubscription.css';

const MySubscription = () => {
  // Placeholder values for now
  const stats = [
    { label: 'People Enriched', value: 0 },
    { label: 'Campaigns Created', value: 0 },
    { label: 'Contacts Added', value: 0 },
    { label: 'Sequences Run', value: 0 },
  ];

  const planFeatures = [
    'Up to 5,000 enrichments',
    'Unlimited campaigns',
    'Advanced analytics',
    'Team management',
  ];

  return (
    <div className="subscription-container">
      <div className="subscription-header">
        <div className="subscription-title">My Subscription</div>
        
      </div>
      <div className="subscription-tabs">
          <button className="tab active">Current Plan</button>
          <button className="tab">Billing History</button>
        </div>
      <div className="subscription-card">
        <div className="plan-banner">
          <span className="trial-badge">Free Trial (8 Days Left)</span>
         
        </div>
        <div className="plan-dates">
          <div className="date-block">
            <span className="date-label">Started On</span>
            <span className="date-value">June 19, 2025</span>
          </div>
          <div className="date-block">
            <span className="date-label">Trial Ends</span>
            <span className="date-value">July 3, 2025</span>
          </div>
        </div>
        {/* Main Top-Level Stats Cards */}
        <div className="main-stats-row">
          {stats.map((stat, idx) => (
            <div className="main-stat-card" key={idx}>
              <div className="main-stat-value">{stat.value}</div>
              <div className="main-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
        {/* Plan Features */}
        <div className="plan-features">
          <div className="features-title">Plan Features</div>
          <div className="features-list">
            {planFeatures.map((feature, idx) => (
              <div className="feature-item" key={idx}>{feature}</div>
            ))}
          </div>
        </div>
        <button className="manage-btn">Manage Subscription</button>
      </div>
    </div>
  );
};

export default MySubscription; 